import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
	FacebookFilled,
	ViberFilled,
	YoutubeFilled,
	TelegramFilled,
	StarLineIcon,
} from "@assets";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
	RootContainer,
	Wrapper,
	Title,
	SocialWrapper,
	DownloadWrapper,
	SocialTitle,
	TopImage,
	AppleFilled,
	PlayStoreFilled,
	ApkFilled,
} from "./AppDownload.style";
import { Flex } from "antd";

const AppDownload = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { social_links } = useSelector((state) => state.app.settings);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const Link = ({ url, children, ...props }) => (
		<a href={url} target="_blank" rel="noreferrer noopen" {...props}>
			{children}
		</a >
	);

	const callHandler = (url) => {
		if (window.flutter_inappwebview?.callHandler) {
			window.flutter_inappwebview.callHandler("onEvent", url);
		}
	}

	return (
		<>
			<Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
			<RootContainer>

				<TopImage />

				<Title>{t("home.appDownloadSubTitle2", {
					appName: t("common.appName")
				})}</Title>

				<StarLineIcon />

				<DownloadWrapper>
					<Flex
						justify="center"
						gap={16}
						style={{ width: '100%' }}
					>
						<Link url={social_links?.app_store_link}>
							<AppleFilled />
						</Link>
						<Link url={social_links?.play_store_link} onClick={() => callHandler(social_links?.play_store_link)}>
							<PlayStoreFilled />
						</Link>
					</Flex>
					<Flex style={{ width: '100%' }}>
						<Link url={social_links?.download_link} onClick={() => callHandler(social_links?.download_link)}>
							<ApkFilled />
						</Link>
					</Flex>
				</DownloadWrapper>

				<StarLineIcon />

				<Wrapper>
					<SocialTitle>{t("home.appDownloadSubTitle1")}</SocialTitle>
					<SocialWrapper>
						<Link url={social_links?.fb_link}>
							<FacebookFilled />
						</Link>
						<Link url={social_links?.viber_link}>
							<ViberFilled />
						</Link>
						<Link url={social_links?.telegram_link}>
							<TelegramFilled />
						</Link>
						<Link url={social_links?.youtube_link}>
							<YoutubeFilled />
						</Link>
					</SocialWrapper>
				</Wrapper>

			</RootContainer>
		</>
	);
};

export default AppDownload;
